import { Controller } from 'stimulus'
import { dollarsToCents } from './dollars_to_cents.js'

export default class extends Controller {
  static values = {
    taxPercent: Number,
    allowNegative: Boolean,
    preserveBlank: Boolean,
  }

  static targets = ['hiddenCentsInput', 'dollarsInput', 'taxSelect']

  connect() {
    this.updateDollarsInputFromHiddenField()

    setTimeout(() => {
      this.updateDollarsInputFromHiddenField()
    }, 100)

    this.connected = true
  }

  taxFactor() {
    return 1 + parseFloat(this.taxPercentValue) / 100
  }

  currentTaxMode() {
    return this.taxSelectTarget.value
  }

  isInclTaxMode() {
    return this.currentTaxMode() === 'incl_tax'
  }

  updateDollarsInputFromHiddenField() {
    const hiddenValue = this.hiddenCentsInputTarget.value
    if (
      hiddenValue === '' ||
      hiddenValue === null ||
      hiddenValue === undefined
    ) {
      this.dollarsInputTarget.value = ''
      this.dollarsInputTarget.parentNode.dataset.value = ''
      return
    }

    const centsExclTax = parseInt(hiddenValue, 10) || 0
    const dollarsExclTax = centsExclTax / 100

    let displayValue
    if (this.isInclTaxMode()) {
      displayValue = dollarsExclTax * this.taxFactor()
    } else {
      displayValue = dollarsExclTax
    }

    this.dollarsInputTarget.value = this.formatDollars(displayValue)
    this.dollarsInputTarget.parentNode.dataset.value =
      this.dollarsInputTarget.value
  }

  // For other controllers that fill in the amount (in cents, excl. tax)
  setCents(cents) {
    this.hiddenCentsInputTarget.value = cents
    this.updateDollarsInputFromHiddenField()
  }

  centsFromDollars() {
    if (
      this.preserveBlankValue &&
      this.dollarsInputTarget.value.trim() === ''
    ) {
      return ''
    }

    return dollarsToCents(this.dollarsInputTarget.value, {
      inclTax: this.isInclTaxMode(),
      taxPercent: this.taxPercentValue,
      allowNegative: this.allowNegativeValue,
    })
  }

  // Keep the serialized hidden cents field in sync on every keystroke — not only on
  // blur/change — so a form submitted before the field blurs (e.g. clicking "Go advanced"
  // right after typing) never sends an empty amount. ENG-30226.
  onDollarsInput = () => {
    this.hiddenCentsInputTarget.value = this.centsFromDollars()
  }

  onDollarsInputChanged = () => {
    let dollarValue = parseFloat(this.dollarsInputTarget.value) || 0
    if (dollarValue < 0 && !this.allowNegativeValue) dollarValue = 0

    this.hiddenCentsInputTarget.value = this.centsFromDollars()

    this.dollarsInputTarget.value =
      this.hiddenCentsInputTarget.value === ''
        ? ''
        : this.formatDollars(dollarValue)

    this.triggerChangeEvent()
  }

  onTaxModeChanged = () => {
    this.updateDollarsInputFromHiddenField()
  }

  triggerChangeEvent() {
    if (this.connected) {
      this.hiddenCentsInputTarget.dispatchEvent(new Event('change'))
    }
  }

  formatDollars(dollars) {
    return (parseFloat(dollars) || 0).toFixed(2)
  }
}
